import React from 'react';
import './empresa.css';
import FilosofiaImg from '../../Images/empresa-filosofia.jpg';

function empresa() {
    return (
    <section>
      <section className='Filosofia'>
        <div className='Filosofia-imagen'>
          <img src={FilosofiaImg} alt='Imagen de filosofia'></img>
        </div>
        <div className='Filosofia-texto'>
          <div className='Filosofia-texto-titulo'><h1>Gis Sewing Machine SS de RL de CV</h1></div>
          <div className='Filosofia-texto-mision'><p>En Gis Sewing Machine, siempre hemos querido mantener nuestra visión y nuestros valores intactos, que han estado siempre enfocados en la búsqueda de la máxima calidad en todos nuestros productos y servicios.</p></div>
          <div className='Filosofia-texto-titulo2'><h1>NUESTRA FILOSOFÍA</h1></div>
          <div className='Filosofia-texto-mision2'><p>Somos una empresa proveedora de maquinaria de coser industrial y refacciones de repuestos, servicios de soporte de técnico, con personal altamente calificados para atenderlos personalmente como usted se merece.</p></div>
        </div>
      </section>
    </section>
    );
  }
  
export default empresa;
  